module.exports = __webpack_public_path__ + "img/wallet.1603b02.png";